import { HttpErrorResponse } from '@angular/common/http';

const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again later.';

interface ErrorDetail {
  msg: string;
}

const isStringDetail = (detail: unknown): detail is string =>
  typeof detail === 'string';

const isArrayDetail = (detail: unknown): detail is ErrorDetail[] =>
  Array.isArray(detail);

const formatArrayDetail = (detail: ErrorDetail[]): string => {
  const messages = detail.map((item) => {
    const msg = item.msg?.trim();

    return /[.!?]$/.test(msg) ? msg : msg + '.';
  });

  const allSame = messages.every((msg) => msg === messages[0]);

  return allSame ? messages[0] : messages.join('\n');
};

export const getApiErrorMessage = (error: HttpErrorResponse): string => {
  const detail = error.error?.detail;

  if (!detail) {
    return DEFAULT_ERROR_MESSAGE;
  }

  if (isStringDetail(detail)) {
    return detail + '.';
  }

  if (isArrayDetail(detail)) {
    return formatArrayDetail(detail);
  }

  return DEFAULT_ERROR_MESSAGE;
};
